import React from 'react'

interface SearchProgressBarProps {
    completed: number
    total: number
}

export const SearchProgressBar: React.FC<SearchProgressBarProps> = ({ completed, total }) => {
    return (
        <div className='relative h-5 w-full'>
            <div className='absolute inset-0 rounded-full bg-gray-500 dark:bg-gray-700'>
                <div
                    className='h-full transform rounded-full bg-blue-600 transition-all duration-300 ease-in-out'
                    style={{ width: `${(completed / total) * 100}%` }}
                />
            </div>
            <div className='absolute inset-0 flex items-center justify-center'>
                <span className='text-xs font-bold text-white transition-opacity duration-200'>
                    {completed}/{total}
                </span>
            </div>
        </div>
    )
}

export default SearchProgressBar
